/**
 * The operations an entitlement override can unblock.
 *
 * A capability IS A GraphQL FIELD NAME on the clinic BFF, checked by name in its
 * `capabilitySets.js`. That makes free text here a typo that grants nothing and
 * reports success — the operator closes the ticket, the clinic still cannot
 * book, and nothing anywhere says why. Picking from a list is the difference
 * between an un-break that works and one that silently does not.
 *
 * MIRRORS `parsina.bff.clinic/src/auth/capabilitySets.js`, deliberately as a
 * local list rather than an import: those are separate repos and separate
 * deploys, so a cross-submodule import would be a lie about how this ships. The
 * honest cost is that a new gated operation means editing two files — which the
 * `label` being a catalogue KEY makes loud rather than silent, since a missing
 * key renders as a humanised fragment an operator will report.
 *
 * These are the ones support is actually asked about: the gates a clinic hits.
 * The list is intentionally not exhaustive — an override is a targeted un-break,
 * and a picker with sixty entries is one an operator scrolls past.
 */
export const OVERRIDE_CAPABILITIES = [
  'createAppointment',
  'addDoctorToClinic',
  'addStaffToClinic',
  'generateInvitationCode',
  'accountingCreateInvoice',
  'accountingRecordPayment',
  'accountingOpenShift',
  'createCustomService',
  'createExpense',
  'createWarehousingItem',
  'reportStats',
  'openChatConversation',
  'parsePatientVoiceTranscript',
];

/** Catalogue key for a capability's operator-facing name. */
export const capabilityLabelKey = (capability) => `clinic.capability.${capability}`;
